import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";
import { parsePaginatedResponse } from "../../utils/parsePaginatedResponse";

const ACTIVITY_LOG_KEYS = [
  "activityLogs",
  "activitylogs",
  "activityLog",
  "activitylog",
  "logs",
];

export const useViewActivityLog = ({ page, limit, q } = {}) => {
  const isPaginated = page !== undefined && limit !== undefined;
  const trimmedQ = q?.trim?.() ?? "";

  return useQuery({
    queryKey: isPaginated
      ? ["viewActivityLog", page, limit, trimmedQ]
      : ["viewActivityLog"],
    queryFn: async () => {
      const params = {};
      if (isPaginated) {
        params.page = page;
        params.limit = limit;
        if (trimmedQ) params.q = trimmedQ;
      }

      const res = await api.get("/activity-log/show", { params });

      if (isPaginated) {
        const parsed = parsePaginatedResponse(
          res.data,
          ACTIVITY_LOG_KEYS,
          limit,
        );
        return {
          activityLogs: parsed.items,
          pagination: parsed.pagination,
        };
      }

      return res.data;
    },
    placeholderData: isPaginated
      ? (previousData) => previousData
      : undefined,
    staleTime: isPaginated ? 60_000 : undefined,
  });
};
